module.exports = __webpack_public_path__ + "img/xiaApp1.8fa66d23.png";